var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 45,
    viewBox: "0 0 51 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5185 20.3795C23.3333 20.361 23.1111 20.361 22.9074 20.3795C18.5 20.2314 15 16.6203 15 12.1758C15 7.6388 18.6667 3.95361 23.2222 3.95361C27.7593 3.95361 31.4444 7.6388 31.4444 12.1758C31.4259 16.6203 27.9259 20.2314 23.5185 20.3795Z",
    stroke: "#34906E",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9439 7.65771C40.5365 7.65771 43.4253 10.5651 43.4253 14.1392C43.4253 17.6392 40.6476 20.491 37.1846 20.6207C37.0365 20.6022 36.8698 20.6022 36.7031 20.6207",
    stroke: "#34906E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2595 27.2131C9.77807 30.2131 9.77807 35.1019 14.2595 38.0834C19.3521 41.4908 27.704 41.4908 32.7966 38.0834C37.2781 35.0834 37.2781 30.1945 32.7966 27.2131C27.7225 23.8242 19.3707 23.8242 14.2595 27.2131Z",
    stroke: "#34906E",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5195 37.2874C41.8529 37.0096 43.1121 36.4726 44.1492 35.6763C47.038 33.5096 47.038 29.9355 44.1492 27.7689C43.1306 26.9911 41.8899 26.4726 40.5751 26.1763",
    stroke: "#34906E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.55664 37.2869C5.27868 37.0091 4.07173 36.4721 3.07776 35.6758C0.308859 33.5091 0.308859 29.935 3.07776 27.7684C4.05398 26.9906 5.24319 26.4721 6.50339 26.1758",
    stroke: "#34906E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99449 7.65723C6.03571 7.65723 2.85236 10.5646 2.85236 14.1387C2.85236 17.6387 5.91327 20.4906 9.72921 20.6202C9.89246 20.6017 10.0761 20.6017 10.2598 20.6202",
    stroke: "#34906E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHr);
export default __webpack_public_path__ + "static/media/HR.2f6984150911a14252128ff0f70cce5b.svg";
export { ForwardRef as ReactComponent };